export const copyToClipboard = async (text: string): Promise<void> => await navigator.clipboard.writeText(text)
